import React from "react";
import "./OwStatusEnumIcon.scss";
import StatusEnum from "../../../models/StatusEnum";
import { OwIconButton } from "../OwIconButton/OwIconButton";

type Props = {
    status: StatusEnum;
};

export const OwStatusEnumIcon: React.FC<Props> = (props) => {
    return (
        <div className={"OwStatusEnumIcon"}>
            {props.status === StatusEnum.NOT_STARTED ? <i className={"fa-lg far fa-circle"} /> : null}
            {props.status === StatusEnum.PARTIAL ? <i className={"fa-lg fas fa-adjust text-warning"} /> : null}
            {props.status === StatusEnum.COMPLETED ? <i className={"fa-lg fas fa-check-circle text-success"} /> : null}
        </div>
    );
};
